module.exports = __webpack_public_path__ + "img/pt_Ecran 3.ee097d26.png";